module.exports = __webpack_public_path__ + "img/next_mob.2beb43fb.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":720,"height":460,"variants":[{"file":"img/next_mob-480w.21cd8e36344f.webp","width":480},{"file":"img/next_mob-720w.0c49a5b623b9.webp","width":720}]};
}